import React from "react";
import { Select } from "antd";
import { traducirPagina } from "../../librerias/funciones";
const { Option } = Select;


const CPSelect = ({ registers = [], value = undefined, allowClear = true, placeholder = `${traducirPagina("Todos")}`, onChange = () => { } }) => {
    return (
        <Select
            showSearch
            allowClear={allowClear}
            placeholder={placeholder}
            style={{ width: "100%"}}
            size="large"
            
            optionFilterProp="children"
            value={value}
            onChange={(e) => {
                onChange(e)
            }}
            filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        >
            {
                registers !== null && (
                    registers.map((item, i) => <Option value={item.ID} key={i}>{item.DESCRIPCION}</Option>)
                )
            }
        </Select>
    )
}

export default CPSelect;